import {
  GET_LEAD_API_RESOURCES_FAIL,
  GET_LEAD_API_RESOURCES_FETCHING,
  GET_LEAD_API_RESOURCES_SUCCESS
} from '../actions/leadApiResourcesActions';

const initialState = {
  leadApiResources: [],
  loading: false,
  errors: '',
};

const leadApiResourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_API_RESOURCES_FETCHING:
      return { ...state, loading: true };
    case GET_LEAD_API_RESOURCES_FAIL:
      return { ...state, loading: false, errors: action.payload.message };
    case GET_LEAD_API_RESOURCES_SUCCESS:
      return { ...state,
        leadApiResources: action.payload.leadApiResources,
        loading: false,
        errors: ''
      };
    default:
      return state;
  }
};

export default leadApiResourcesReducer;
